import React, { Fragment, useMemo } from "react"
import ExpenseTable from "../../Common/ExpenseTable/index"
import {
  editableColumnsMarkupAndDiscount,
  editableMobileSoloColumns,
} from "../../../../pages/Shoot/pages/Billing/BillingContext"
import {
  toggleAddSoloPositionDialog,
  toggleClickConfirmationDialog,
} from "../../../../actions/billingDialogs"
import { Box, Button } from "@material-ui/core"
import AddIcon from "@material-ui/icons/Add"
import {
  createSoloItemCall,
  createSoloPositionCall,
  deleteSoloItemCall,
  deleteSoloRoleCall,
  updateSoloItemCall,
} from "../../../../actions/solos"
import { openSnackBar } from "../../../../actions/snack-bar"
import { v4 as uuidv4 } from "uuid"
import isUuid from "../../../../utils/isUuid"
import { useDispatch } from "react-redux"
import useStyles from "./styles"
import { Typography } from "../../../../../node_modules/@material-ui/core/index"
import markUpCalc from "../../../../utils/markUpCalc"
import { clearCrewFromChip } from "../../../../actions/crew"
import { setRoleForCrew, toggleShootDialog } from "../../../../actions/shoots"
import PropTypes from "prop-types"
import { updateItemsOrder } from "../../../../actions/billing"

const SoloTable = ({ soloData = {}, setSoloData = () => {}, type = "" }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const soloId = soloData && soloData[`${type.toLowerCase()}_id`]

  const isDisabled = useMemo(
    () => {
      // if solo invoice, disable if full paid; if solo estimate disable if linked to shoot
      return type === "invoice"
        ? soloData && soloData.full_paid
        : soloData && (soloData.shoot_id || soloData.shoot_name)
    },
    [soloData]
  )

  //-------------------- SAVE ITEMS BASED ON EXISTING ITEMS OR NEWLY CREATED ITESM---------------
  const handleSave = (values, actions, item, deal_memo_order) => {
    let expense = {
      item_type: values.item_type,
      description: values.description,
      default_description: item.default_description,
      quantity: values.quantity,
      actual_rate: Number(values.actual_rate),
      discount: Number(values.discount),
      client_rate: Number(values.client_rate),
      role_id: item.role_id,
      shoot_role: item.shoot_role,
      expense_id: item.expense_id,
      type_name: values.type_name,
      is_percentage: values.is_percentage,
      deal_memo_order: deal_memo_order,
    }
    // let stringId = item.item_id.toString()
    if (isUuid(item.expense_id)) {
      dispatch(createSoloItemCall(type, soloId, expense))
        .then(res => {
          let createdExpense = {
            expense_id: res.data[0].id,
            type_name: expense.type_name,
            ...res.data[0],
          }
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
          dispatch(openSnackBar({ message: "Solo item created" }))
          setSoloData(oldState => ({
            ...oldState,
            roles: oldState.roles.map(x => {
              if (createdExpense.shoot_role === x.shoot_role) {
                x.expenses = x.expenses.map(y => {
                  if (y.expense_id === expense.expense_id) {
                    return createdExpense
                  } else {
                    return y
                  }
                })
                return x
              } else {
                return x
              }
            }),
          }))
        })
        .catch(err => {
          console.log(err)
          dispatch(openSnackBar({ message: "Error creating solo item" }))
          actions.resetForm({ values: values })
          actions.setSubmitting(false)
        })
    } else {
      dispatch(updateSoloItemCall(type, item.expense_id, expense))
        .then(() => {
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
          setSoloData(oldState => ({
            ...oldState,
            roles: oldState.roles.map(x => {
              if (expense.shoot_role === x.shoot_role) {
                x.expenses = x.expenses.map(y => {
                  if (y.expense_id === expense.expense_id) {
                    return expense
                  } else {
                    return y
                  }
                })
                return x
              } else {
                return x
              }
            }),
          }))
          dispatch(openSnackBar({ message: "Item updated" }))
        })
        .catch(err => {
          console.log(err)
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
          dispatch(openSnackBar({ message: "Failed to update item" }))
        })
    }
  }

  // ---------------------------------- ADD EXPENSE ITEMS ------------------------------
  const handleAdd = role => {
    let newExpense = {
      expense_id: uuidv4(),
      name: "Position",
      quantity: 0,
      actual_rate: 0,
      total: 0,
      discount: 0,
      shoot_role: role.id,
      role_id: role.role_id,
      client_rate: 0,
      description: "Add a description",
      user_id: null,
      is_percentage: 0,
    }
    setSoloData(oldState => ({
      ...oldState,
      roles: oldState.roles.map(x => {
        if (Number(x.shoot_role || x.id) === Number(role.id)) {
          let newRole = { ...x }
          newRole.expenses = [...newRole.expenses, newExpense]
          return newRole
        } else {
          return x
        }
      }),
    }))
  }
  //------------------------DELETE EXPENSE ITEMS ------------------------------------
  const handleDelete = (type, id, shootRole) => {
    dispatch(deleteSoloItemCall(type, id))
      .then(() => {
        setSoloData(oldState => {
          let newState = { ...oldState }
          return {
            ...newState,
            roles: oldState.roles.map(x => {
              let roleCopy = { ...x }
              if (roleCopy.shoot_role === shootRole) {
                roleCopy.expenses = [
                  ...roleCopy.expenses.filter(y => {
                    let newy = { ...y }
                    if (y.expense_id !== id) {
                      return newy
                    }
                  }),
                ]
                return { ...roleCopy }
              } else {
                return { ...roleCopy }
              }
            }),
          }
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  const openDeleteConfirmation = item => {
    let data = {
      action: "delete this expense",
      confirmationFunc: handleDelete,
      funcArgs: [type, item.expense_id, item.shoot_role],
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }

  //------------------------------CREATE AND ADD POSITIONS------------------------------------------
  const createPosition = (role, handleClose) => {
    let data = { role_id: role.id }
    dispatch(createSoloPositionCall(type, soloId, data))
      .then(res => {
        let newPosition = {
          role_id: role.id,
          name: role.name,
          [`${type}_id`]: soloId,
          shoot_role: res.data[0].id,
          expenses: [],
        }

        setSoloData(oldState => ({
          ...oldState,
          roles: [...oldState.roles, newPosition],
        }))
        dispatch(openSnackBar({ message: "Position Created" }))
        handleClose()
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error creating position" }))
        handleClose()
      })
  }

  const addPosition = name => {
    let data = { func: createPosition }
    dispatch(toggleAddSoloPositionDialog(true, data))
  }
  //----------------------- ASSIGN CREW TO ROLE ------------------------
  const assignCrewToRole = role => {
    dispatch(clearCrewFromChip())
    dispatch(setRoleForCrew(role))
    dispatch(
      toggleShootDialog({
        open: true,
        data: { role: role, type: "add-crew", setSoloData: setSoloData },
      })
    )
  }
  //--------------CREATE GENERIC CREW MEMBER ROLE & ASSIGN USER -------------
  const quickAddCrewMember = () => {
    // no sending id - dialog uses this to decide which code
    let roleData = {
      role_id: 3788,
      name: "CREW MEMBER",
      [`${type}_id`]: soloId,
      expenses: [],
    }
    dispatch(setRoleForCrew(roleData))
    dispatch(
      toggleShootDialog({
        open: true,
        data: { role: roleData, type: "add-crew", setSoloData: setSoloData },
      })
    )
  }

  //---------------------------- DELETE ROLES------------------------
  const deleteSoloRole = (type, shootRoleId) => {
    dispatch(deleteSoloRoleCall(type, shootRoleId))
      .then(() => {
        setSoloData(oldState => {
          return {
            ...oldState,
            roles: oldState.roles.filter(x => x.shoot_role !== shootRoleId),
          }
        })
        dispatch(openSnackBar({ message: "Position Deleted" }))
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error deleting position" }))
      })
  }
  const openDeleteRoleDialog = role => {
    let data = {
      action: "delete this role",
      confirmationFunc: deleteSoloRole,
      funcArgs: [type, role.id],
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  const mobileScreen = viewportWidth < 600
  const tabletScreen = viewportWidth < 960

  //reorder items
  const setItemsOrder = (newItemsArray, roleData) => {
    // dispatch(
    //   reorderUsersRolesArray(newItemsArray, position.id || position.shoot_role)
    // )
    setSoloData(oldState => ({
      ...oldState,
      roles: oldState.roles.map(x => {
        if (roleData.role.id || roleData.role.shoot_role === x.shoot_role) {
          x.expenses = [...newItemsArray]

          return x
        } else {
          return x
        }
      }),
    }))
    let orderData = newItemsArray.map((item, index) => ({
      expenseId: item.expense_id,
      expenseType: type === "estimate" ? "sedmi" : "sidmi",
      order: index + 1,
    }))

    dispatch(updateItemsOrder(orderData))
  }

  const itemsWithOutBeCreated = useMemo(
    () => {
      let unsavedData = []
      if (soloData) {
        soloData.roles.map(role => {
          role.expenses.map(expense => {
            if (expense.expense_id.toString().includes("-")) {
              unsavedData.push(expense)
            }
          })
        })
      }

      return unsavedData.length > 0
    },
    [soloData.roles]
  )

  //------------------------SOLO TABLE----------------------------
  return (
    <Fragment>
      <Box className={classes.container}>
        <ExpenseTable
          columns={
            !tabletScreen
              ? editableColumnsMarkupAndDiscount
              : editableMobileSoloColumns
          }
          data={(soloData && [...soloData.roles]) || []}
        >
          <ExpenseTable.Header />
          <ExpenseTable.RoleGroup isDisabled={isDisabled}>
            <ExpenseTable.RoleBar>
              {window.location.pathname.includes("billing/solo-") ? (
                <Box display="flex">
                  <ExpenseTable.AddCrewMemberButton
                    onClick={assignCrewToRole}
                  />
                  <ExpenseTable.DeleteRoleButton
                    onClick={openDeleteRoleDialog}
                  />
                </Box>
              ) : null}
            </ExpenseTable.RoleBar>
            <ExpenseTable.ItemsGroup
              draggable={!itemsWithOutBeCreated}
              style={!tabletScreen ? { marginLeft: 30 } : {}}
              setItems={setItemsOrder}
            >
              <ExpenseTable.ItemBar isDisabled={isDisabled} onSave={handleSave}>
                {/* NAME START */}
                <ExpenseTable.NameItem
                  style={
                    tabletScreen
                      ? {
                          gridColumn: "1/ span 6",
                          gridRow: "1/1",
                        }
                      : {}
                  }
                />
                {/* NAME END */}
                {/* Quantity START */}
                {!tabletScreen ? (
                  <ExpenseTable.NumberItem valueForProperty="quantity" />
                ) : (
                  <Box
                    style={
                      mobileScreen
                        ? {
                            gridColumn: "type_name-start / actual_rate-start",
                            gridRow: "3/3",
                          }
                        : { gridColumn: "1/1", gridRow: "3/3" }
                    }
                  >
                    <Typography className={classes.mobileLabels}>
                      Qty
                    </Typography>
                    <ExpenseTable.NumberItem valueForProperty="quantity" />
                  </Box>
                )}
                {/* Quantity END */}
                {/* Actual Rate START */}
                {!tabletScreen ? (
                  <ExpenseTable.NumberItem valueForProperty="actual_rate" />
                ) : (
                  <Box
                    style={
                      mobileScreen
                        ? {
                            gridColumn: "actual_rate-start / discount-start",
                            gridRow: "3/3",
                          }
                        : { gridColumn: "2/2", gridRow: "3/3" }
                    }
                  >
                    <Typography className={classes.mobileLabels}>
                      Rate($)
                    </Typography>
                    <ExpenseTable.NumberItem valueForProperty="actual_rate" />
                  </Box>
                )}
                {/* Actual Rate END */}
                {/* Client Rate / Markup START */}
                {!tabletScreen ? (
                  <ExpenseTable.NumberItem
                    valueForProperty="client_rate"
                    InputProps={{
                      classes: {
                        adornedStart: classes.menuButton,
                        input: classes.menuInput,
                      },
                      startAdornment: <ExpenseTable.PercentageButton />,
                    }}
                  />
                ) : (
                  <Box
                    style={
                      mobileScreen
                        ? {
                            gridColumn: "discount-start / total-end",
                            gridRow: "3/3",
                          }
                        : { gridColumn: "3/3", gridRow: "3/3" }
                    }
                  >
                    <Typography className={classes.mobileLabels}>
                      Markup
                    </Typography>
                    <ExpenseTable.NumberItem
                      valueForProperty="client_rate"
                      InputProps={{
                        classes: {
                          adornedStart: classes.menuButton,
                          input: classes.menuInput,
                        },
                        startAdornment: <ExpenseTable.PercentageButton />,
                      }}
                    />
                  </Box>
                )}
                {!tabletScreen ? (
                  <ExpenseTable.NumberItem valueForProperty="discount" />
                ) : (
                  <Box
                    style={
                      mobileScreen
                        ? {
                            gridColumn: "type_name-start / actual_rate-start",
                            gridRow: "4/4",
                          }
                        : { gridColumn: "4/4", gridRow: "3/3" }
                    }
                  >
                    <Typography className={classes.mobileLabels}>
                      Discount($)
                    </Typography>
                    <ExpenseTable.NumberItem valueForProperty="discount" />
                  </Box>
                )}
                {!tabletScreen ? (
                  <ExpenseTable.TotalItem>
                    {values =>
                      values.is_percentage
                        ? (
                            Number(values.actual_rate) *
                              Number(values.quantity) +
                            markUpCalc(
                              values.quantity * values.actual_rate,
                              values.client_rate
                            ) -
                            Number(values.discount)
                          ).toFixed(2)
                        : (
                            Number(values.client_rate) +
                            (Number(values.actual_rate) *
                              Number(values.quantity) -
                              Number(values.discount))
                          ).toFixed(2)
                    }
                  </ExpenseTable.TotalItem>
                ) : (
                  <Box
                    style={
                      mobileScreen
                        ? {
                            gridRow: "4/4",
                            gridColumn: "discount-start / total-end",
                          }
                        : { gridRow: "3/3", gridColumn: "6/6" }
                    }
                  >
                    <Typography className={classes.mobileLabels}>
                      Total($)
                    </Typography>
                    <ExpenseTable.TotalItem>
                      {values =>
                        values.is_percentage
                          ? (
                              Number(values.actual_rate) *
                                Number(values.quantity) +
                              markUpCalc(
                                values.quantity * values.actual_rate,
                                values.client_rate
                              ) -
                              Number(values.discount)
                            ).toFixed(2)
                          : (
                              (values.quantity > 0
                                ? Number(values.client_rate)
                                : 0) +
                              (Number(values.actual_rate) *
                                Number(values.quantity) -
                                Number(values.discount))
                            ).toFixed(2)
                      }
                    </ExpenseTable.TotalItem>
                  </Box>
                )}
                <ExpenseTable.Item
                  valueForProperty="description"
                  style={
                    !tabletScreen
                      ? {
                          gridColumn: "type_name-start / quantity-start",
                          gridRow: "2/2",
                        }
                      : {
                          gridRow: "2/3",
                          gridColumn: "1/ span 6",
                        }
                  }
                />
                <ExpenseTable.FlagButton hideIfNotFlagged />
                <Box
                  style={
                    !tabletScreen
                      ? {
                          gridColumn: "quantity-start / total-end",
                          gridRow: "2/2",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          padding: "0 5px",
                        }
                      : {
                          gridColumn: "quantity-start / total-end",
                          gridRow: "5/5",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          padding: "0 5px",
                          marginBottom: "10px",
                          marginTop: "10px",
                        }
                  }
                >
                  <ExpenseTable.DeleteButton onClick={openDeleteConfirmation} />
                  <ExpenseTable.SaveButton />
                </Box>
              </ExpenseTable.ItemBar>
            </ExpenseTable.ItemsGroup>
            <ExpenseTable.AddButton onClick={handleAdd} />
          </ExpenseTable.RoleGroup>
        </ExpenseTable>
      </Box>
      <Box display="flex" justifyContent="flex-start">
        <Button color="primary" disabled={isDisabled} onClick={addPosition}>
          <AddIcon style={{ fontSize: "24px" }} />
          Add Position
        </Button>
        <Button
          color="secondary"
          style={{ marginLeft: "10px" }}
          disabled={isDisabled}
          onClick={quickAddCrewMember}
        >
          <AddIcon style={{ fontSize: "24px" }} />
          Add Crew Member
        </Button>
      </Box>
    </Fragment>
  )
}

SoloTable.propTypes = {
  soloData: PropTypes.object,
  setSoloData: PropTypes.func,
  type: PropTypes.string,
}

export default SoloTable
